<template>
  <div>
    
    <div class="tr" :class="{even: index % 2 === 0}">

      <div class="data-item">
        <div class="fw-bold w-100"><a @click="lrrRefClicked(alert.lrrRef)" data-tippy-content="open in base station view">{{alert.lrrRef}}</a></div>
        <div :title="alert.baseStation.name">{{formatName(alert.baseStation.name)}}</div>
        <div>
          <span class="text-dark small"><font-awesome-icon icon="tag"/> {{alert.baseStation.commercialName}}</span>
        </div>
        <div>
          <span class="text-dark small"><font-awesome-icon icon="suitcase-rolling"/> {{alert.baseStation.supplierId}}</span>
        </div>
        <div v-if="alert.type === 'conn-status'">
          <span class="badge bg-danger"><font-awesome-icon icon="plug"/> LOST CONNECTION</span>
        </div>
        <div v-else><font-awesome-icon icon="danger"/>{{alert.type}}</div>

        <div>{{formatTs(alert.startTs).time}}</div>
        <div class="font-italic">{{formatTs(alert.startTs).ago}}</div>

        <div class="mt-2">
          <button 
            type="button" 
            class="btn btn-danger btn-sm" 
            data-tippy-content="clear alert"
            @click="clearAlert(alert.alertId)"
            :class="{disabled:disabled}"
>
            <font-awesome-icon icon="trash"/> clear alert
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { sharedState } from '@/shared';
import dayjs from '@/plugins/dayjs';
import tippy from 'tippy.js';
import { FullAlert } from '@/types';

interface Props {
  alert: FullAlert;
  index: number;
  disabled: boolean;
}

withDefaults(defineProps<Props>(), {
  alert: () => ({}) as FullAlert,
  index: 0,
  disabled: false
});

const emit = defineEmits<{
  'clear-alert': [alertId: string];
}>();

const router = useRouter();


onMounted(async () => {
  tippy('[data-tippy-content]');
});

const formatTs = (ts: number | undefined): {time: string, ago: string} => {
  return {
    time: ts ? dayjs(ts).format('L LT') : 'N/A',
    ago: ts ? dayjs(ts).fromNow() : 'N/A'
  };
};

const formatName = (name: string): string => {
  if(name.length <= 30)
    return name;
  return name.substring(0, 27) + '...';
};

const lrrRefClicked = (lrrRef: string) => {
  sharedState.lrrRef = lrrRef;
  router.push({ name: 'base-stations' });
};

const clearAlert = (alertId: string) => {
  emit('clear-alert', alertId);
};

</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

.tr {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
}

.tr.even {
  background-color: $bgColourLight;
}

.left, .right {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.data-item {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
}

.data-section {
  display: flex;
  flex-direction: column;
  margin-top:3px;
  margin-bottom:3px;
}


.badge.larger {
  font-size: 85%;
}

.badge {
  padding: 0.30em 0.4em;
}

a {
  font-weight: bold;
  color: $bgColour !important;
  cursor: pointer;
}

.clear {
  font-size: 0.7em;
}

</style>